import { Component, Inject, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { UntypedFormControl } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../providers/shared.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-raise-support-ticket',
  templateUrl: './raise-support-ticket.component.html',
  styleUrls: ['./raise-support-ticket.component.scss']
})
export class RaiseSupportTicketComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInput!: ElementRef;
  isDiscountApplicable: boolean = false
  public queryData: any = {};
  isDiscount!: boolean;
  isShop: boolean = false
  isHome: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  entityHash: string = '';
  hideRequiredControl = new UntypedFormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    public dialog: MatDialogRef<RaiseSupportTicketComponent>
  ) {
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          file_url: res.result?.url,
          file_thumb_url: res.result?.thumbnail,
        });
        this.loader = false;
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_CREATE_SUPPORT_TICKET){
        if(res.result){
          this.loaderservice.showLoader = false
          this.dialog.close({msg: 'success'})
        }
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_CREATE_SUPPORT_TICKET_RESPONSE){
        if(res.result){
          this.loaderservice.showLoader = false
          this.dialog.close({msg: 'success'})
        }
      }
 
    });
  }
  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  priceCheker(){
    
    if(this.isHomeSpecific && !this.queryData.home_rate){
      return true
    }
    else if(this.isShopSpecific && !this.queryData.shop_rate){
      return true
    }
    else if(!this.isHomeSpecific && !this.isShopSpecific){
      return true
    }
    else{
      return false
    }
  }
  discountChecker(){
    console.log();
    
    if(this.isDiscountApplicable){
      
      if(!this.queryData.discountType || !this.queryData.discountAmount){
        return true
      }else{
        return false
      }
    }else{
      return false
    }
  }
  ngOnInit(): void {
   

  }
  change(event:any){
    console.log(event);
    if(event.checked == true && event.source.value == 'home'){
      this.isHomeSpecific = true
      this.queryData.homeStatus = 1
    } if(event.checked == true && event.source.value == 'shop'){
      this.isShopSpecific = true
      this.queryData.shopStatus = 1
    } if(event.checked == false && event.source.value == 'home'){
      this.isHomeSpecific = false
      this.queryData.homeStatus = 0
      this.queryData.home_rate = null
      this.queryData.homeDiscountedPrice = null
    }if(event.checked == false && event.source.value == 'shop'){
      this.isShopSpecific = false
      this.queryData.shopStatus = 0
      this.queryData.shop_rate = null
      this.queryData.shopDiscountedPrice = null
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.queryData.discountStatus = 1
    }if(event.target.value == 'not-applicable'){
      this.queryData.discountStatus = 0
      this.queryData.discountAmount = null
      this.queryData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.queryData.homeDiscountedPrice = null
      this.queryData.shopDiscountedPrice = null
    }

  }

  discType(event:any){
    if(event.target.value == 'percent' ){
      this.queryData.discountType = 1
    }if(event.target.value == 'amount'){
      this.queryData.discountType = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  submitQuery(){
    if(!this.parentData.data){
      let obj = {
        "account_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        "entity_hash": localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH),
        "subject": this.queryData.subject,
        "description": this.queryData.description,
        "type": 1,//business
        "files": this.assetList,
        "name":  localStorage.getItem(SM_CONSTANTS.OWNER_NAME),
        "creator_type": "1", //business
        "user_image":  localStorage.getItem(SM_CONSTANTS.OWNER_IMAGE)
    }
  
    console.log(obj)
    this.loaderservice.showLoader = true
    this._apiService.createSupportTicket(obj)
    }
    else{
      let obj = {
        "account_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        "support_ticket_hash": this.parentData.data,
        "description": this.queryData.description,
        "files": this.assetList,
        "name":  localStorage.getItem(SM_CONSTANTS.OWNER_NAME),
        "creator_type": "1", //business
        "user_image":  localStorage.getItem(SM_CONSTANTS.OWNER_IMAGE),
        "resolve_status": 0
    }
  
    console.log(obj)
    this.loaderservice.showLoader = true
    this._apiService.createSupportTicketResponse(obj)
    }

  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  // locationAutoComplete(event: any) {
  //   console.log('location', event.place.address_components);
  //   // administrative_area_level_1 = state
  //   // locality = city
  //   // country = country
  //   event.place.address_components?.forEach((data: any) => {
  //     let type = data.types[0];
  //     console.log(type);
  //     if (type === 'administrative_area_level_1') {
  //       this.queryData.targetState = data?.long_name;
  //     } else if (type === 'locality') {
  //       this.queryData.targetCity = data.long_name;
  //     } else if (type === 'country') {
  //       this.queryData.targetCountry = data.long_name;
  //     }
  //   });
  // }

  onToggleChange(event: any){
    
    if(event.checked){
      this.isDiscountApplicable = true
      this.queryData.discountStatus = 1
    }
    else if(!event.checked){
      this.isDiscountApplicable = false
      this.queryData.discountStatus = 0
      this.queryData.discountAmount = null
      this.queryData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.queryData.homeDiscountedPrice = null
      this.queryData.shopDiscountedPrice = null
    }
  }

  triggerFileInput() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e: any) => this.onUploadImage(e);
    input.click();
  }


}
